export default __webpack_public_path__ + "static/media/salt-busd.15f18ca8.png";